module.exports = __webpack_public_path__ + "static/media/plain.502b343e.svg";